/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LuBillEtransferDataResponse } from './LuBillEtransferDataResponse';
import {
    LuBillEtransferDataResponseFromJSON,
    LuBillEtransferDataResponseFromJSONTyped,
    LuBillEtransferDataResponseToJSON,
    LuBillEtransferDataResponseToJSONTyped,
} from './LuBillEtransferDataResponse';

/**
 * Response for get patient documents
 * @export
 * @interface PatientDocumentResponse
 */
export interface PatientDocumentResponse {
    /**
     * Unique identifier of the invoice
     * @type {number}
     * @memberof PatientDocumentResponse
     */
    patientDocumentId?: number;
    /**
     * ID of the linked invoice, null if not yet finalized
     * @type {number}
     * @memberof PatientDocumentResponse
     */
    invoiceId?: number | null;
    /**
     * the template status
     * @type {string}
     * @memberof PatientDocumentResponse
     */
    templateStatus?: string;
    /**
     * the original text
     * @type {string}
     * @memberof PatientDocumentResponse
     */
    originalText?: string;
    /**
     * the healthPro type
     * @type {string}
     * @memberof PatientDocumentResponse
     */
    healthProType?: string;
    /**
     * the finding end date
     * @type {string}
     * @memberof PatientDocumentResponse
     */
    findingEndDateTime?: string;
    /**
     * the finding start date
     * @type {string}
     * @memberof PatientDocumentResponse
     */
    findingStartDateTime?: string;
    /**
     * 
     * @type {LuBillEtransferDataResponse}
     * @memberof PatientDocumentResponse
     */
    luBillEtransferData?: LuBillEtransferDataResponse;
}

/**
 * Check if a given object implements the PatientDocumentResponse interface.
 */
export function instanceOfPatientDocumentResponse(value: object): value is PatientDocumentResponse {
    return true;
}

export function PatientDocumentResponseFromJSON(json: any): PatientDocumentResponse {
    return PatientDocumentResponseFromJSONTyped(json, false);
}

export function PatientDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'patientDocumentId': json['patientDocumentId'] == null ? undefined : json['patientDocumentId'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
        'templateStatus': json['templateStatus'] == null ? undefined : json['templateStatus'],
        'originalText': json['originalText'] == null ? undefined : json['originalText'],
        'healthProType': json['healthProType'] == null ? undefined : json['healthProType'],
        'findingEndDateTime': json['findingEndDateTime'] == null ? undefined : json['findingEndDateTime'],
        'findingStartDateTime': json['findingStartDateTime'] == null ? undefined : json['findingStartDateTime'],
        'luBillEtransferData': json['luBillEtransferData'] == null ? undefined : LuBillEtransferDataResponseFromJSON(json['luBillEtransferData']),
    };
}

export function PatientDocumentResponseToJSON(json: any): PatientDocumentResponse {
    return PatientDocumentResponseToJSONTyped(json, false);
}

export function PatientDocumentResponseToJSONTyped(value?: PatientDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientDocumentId': value['patientDocumentId'],
        'invoiceId': value['invoiceId'],
        'templateStatus': value['templateStatus'],
        'originalText': value['originalText'],
        'healthProType': value['healthProType'],
        'findingEndDateTime': value['findingEndDateTime'],
        'findingStartDateTime': value['findingStartDateTime'],
        'luBillEtransferData': LuBillEtransferDataResponseToJSON(value['luBillEtransferData']),
    };
}

